/**
 * Standard input chrome for plain <input> elements that cannot use the
 * Catalyst <Input> wrapper (controlled inputs, class components, popovers).
 *
 * Source of truth: components/Catalyst/input.tsx — same rest border, background
 * and focus effect (indigo border + inset indigo/30 ring). Callers add their own
 * padding and text-size classes.
 */
export const standardInputClasses =
  'appearance-none rounded-lg text-zinc-950 dark:text-white placeholder:text-gray-400 ' +
  'border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 ' +
  'bg-white shadow-sm dark:shadow-none dark:bg-white/5 ' +
  'focus:outline-hidden focus:border-indigo-500 dark:focus:border-indigo-400 focus:ring-2 focus:ring-inset focus:ring-indigo-500/30';

/** focus-within variant for composite controls (e.g. tag inputs) where the box, not the inner input, carries the border. */
export const standardInputContainerClasses =
  'rounded-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 ' +
  'bg-white shadow-sm dark:shadow-none dark:bg-white/5 ' +
  'focus-within:border-indigo-500 dark:focus-within:border-indigo-400 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500/30';
